module.exports = __webpack_public_path__ + "img/wf-project.42fc1a49.svg";